<app-background type="dynamic" [delayMs]="3000" *ngIf="displayImageBackground"></app-background>
<div fxLayout="row" fxLayoutAlign="start stretch" class="main-container"
     [style.background]="displayImageBackground ? 'transparent' : 'black'">
    <app-session-view *ngIf="scriptLoaded" fxLayout="row" fxLayoutAlign="stretch"
                      (displayImageBackground)="onDisplayImageBackground($event)"></app-session-view>
</div>